// extracted by mini-css-extract-plugin
export default {"container":"ContactPage_container__uefXP","flex":"ContactPage_flex__leiTn","form":"ContactPage_form__pIkbc","heading":"ContactPage_heading__XjsXm"};